module.exports = "<div class=form-group> <br> <label ng-transclude=translatableLabel></label> <p> <a ng-href=\"{{:: $ctrl.url }}\" target=_blank>{{:: $ctrl.text }}</a> </p> </div>";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/widgets/static/link/partial.html
// module id = 561
// module chunks = 0